module.exports = __webpack_public_path__ + "img/home-control.a3fc8351.png";